import { AppRequestsDocument } from 'src/graphql/actions/appRequests/appRequests.query';
import { apolloClient as client } from 'src/graphql/client/apollo-client';

export const refetchAppRequests = () => {
  client.cache.evict({ fieldName: 'appRequests' });
  client.cache.gc();
  client.refetchQueries({
    include: [AppRequestsDocument],
  });
};
